import { render, staticRenderFns } from "./User.vue?vue&type=template&id=edb74688&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=edb74688&prod&lang=sass&scoped=true"
import style1 from "./User.vue?vue&type=style&index=1&id=edb74688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb74688",
  null
  
)

export default component.exports